var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search',{attrs:{"handleOptions":_vm.handleReturnSearch,"getData":_vm.getReturnData}}),_c('List',{attrs:{"page":_vm.returnPage,"handleOptions":_vm.handleReturnSearch,"getData":_vm.getReturnData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }